/* eslint-disable no-unused-vars */

const config = {
  root: document.getElementsByClassName('layout-container')[0],
};

/**
 * @description Initialisation de bs-breakpoints
 * @see https://github.com/Johann-S/bs-breakpoints/
 */
document.addEventListener('DOMContentLoaded', () => {
  bsBreakpoints.init();
});
